/**
 * ./store/configure-store.js
 */

/**
 * Dependencies
 */
import { createStore,combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
//import { createLogger } from 'redux-logger'
import { routerReducer } from 'react-router-redux'

//import { composeWithDevTools } from 'redux-devtools-extension';
/**
 * Importing our reducer
 */
import reducer from '../reducers'
//const middleware = routerMiddleware(history)
//const middleware = routerMiddleware(history)
/**
 * Apply the thunk and logging middleware to our store
 */


let createStoreWithMiddleware
 if (process.env.NODE_ENV !== 'production') {
   createStoreWithMiddleware =
   compose(
         applyMiddleware(thunk),
         //middleware
       )(createStore)
} else {
  createStoreWithMiddleware =
  compose(
        applyMiddleware(thunk),
      //  middleware
      )(createStore)
}



/**
 * Export the module as a function to create our store with
 */
export function configureStore(initialState) {
  combineReducers({
    ...reducer,
    router: routerReducer
  })

    const store = createStoreWithMiddleware(reducer,  initialState,   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())



  if (module.hot) {
    /**
     * Enable Webpack hot module replacement for reducers
     */
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers')
      store.replaceReducer(nextReducer)
    })
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configure-store.js